module.exports = {"440783001":"三埠街道","440783002":"长沙街道","440783103":"沙塘镇","440783104":"苍城镇","440783105":"龙胜镇","440783106":"大沙镇","440783107":"马冈镇","440783108":"塘口镇","440783109":"赤坎镇","440783110":"百合镇","440783111":"蚬冈镇","440783112":"金鸡镇","440783115":"月山镇","440783116":"赤水镇","440783117":"水口镇","440783400":"翠山湖新区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440783.json
// module id = 2120
// module chunks = 0